export default "__VITE_ASSET__B92c4on3__"